//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FinishMessage from './FinishMessage.vue'
import ValidationContainer from '~/components/Validation/ValidationContainer.vue'
import Button from '~/components/Shared/Button.vue'
export default {
  components: {
    Button,
    ValidationContainer,
    FinishMessage,
  },
}
